import type { FaireProductEntity } from "../../entity_types/product";

export const p_ce73zbd4hx: FaireProductEntity = {
  token: "p_ce73zbd4hx",
  type: "product",
  name: "Hawaiian Mix Salt Water Taffy",
  brandName: "Hawaiian Sweets",
  imageUrl:
    "https://cdn.faire.com/fastly/b19ffbb4ea2e78b36c6d472c88bb6dc0385f9a76a24d70a342a78a897fa02260.jpeg",
  priceDollars: 5.49,
  description: "",
  categoryTokens: ["cat_accessories"],
  tags: [],
  meta: {
    source: "mock",
    importedAt: "2026-03-24T13:23:30Z",
    importedBy: "retailerThemesSeed-migration",
  },
  freeShipping: true,
  brandAvatarUrl:
    "https://cdn.faire.com/fastly/c665126c08e065f795a95eeaa5c538ef7ae31bd46bff34bce1b7ecda4131f082.jpeg",
  weight: 0.5,
  dimensions: {
    width: 4,
    height: 4,
    depth: 2,
  },
  inStock: true,
};
